import { useThrottleFn } from '@vueuse/core';
import { ampli } from '@pkg/analytics-helper/src/ampli';
import { ExtendAmplitudeEvents } from '@pkg/analytics-helper/src/amplitude/extendAmplitudeEvents';
import { getPageType } from '@pkg/analytics-helper/src/utilities/amplitudePageContext';

export default defineNuxtPlugin((nuxtApp) => {
  const plugin = new ExtendAmplitudeEvents();
  nuxtApp.provide('ExtendAmplitudeEvents', plugin);

  if (!import.meta.client) {
    return;
  }

  const thresholds = [25, 50, 75, 100];

  let triggered = new Set<number>();

  const getScrollPercent = () => {
    const scrollTop = window.scrollY;
    const docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (docHeight <= 0) { return 100; }

    return (scrollTop / docHeight) * 100;
  };

  const track = (percent: number) => {
    ampli.track({
      event_type: 'scroll_depth_reached',
      user_properties: {
        scroll_depth_percent: percent,
        page_type: getPageType(window.location.href),
      },
    });
  };

  const onScroll = useThrottleFn(() => {
    const percent = getScrollPercent();

    thresholds.forEach((threshold) => {
      if (percent >= threshold && !triggered.has(threshold)) {
        triggered.add(threshold);
        track(threshold);
      }
    });
  }, 200);

  const reset = () => {
    triggered = new Set();
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  nuxtApp.hook('page:finish', () => {
    reset();
  });

  nuxtApp.hook('page:start', () => {
    reset();
  });
});

// Type declaration for the plugin
declare module '#app' {
  interface NuxtApp {
    $ExtendAmplitudeEvents: ExtendAmplitudeEvents;
  }
}
